export enum APP_IDENTIFIER {
  CASE_MANAGEMENT = "CASE_MANAGEMENT",
  CLIENT_PORTAL = "CLIENT_PORTAL",
  APPLICANT_PORTAL = "APPLICANT_PORTAL",
}

/** Hide Chrome PDF chrome so the file sits in the report like PactSafe HTML. */
export const REPORT_ATTACHMENT_PDF_VIEWER_HASH =
  "toolbar=0&navpanes=0&scrollbar=0&view=FitH";

/** Fallback when page count is unknown so longer PDFs stay scrollable. */
export const REPORT_ATTACHMENT_PDF_VIEWER_HASH_SCROLLABLE =
  "toolbar=0&navpanes=0&scrollbar=1&view=FitH";

/** Minimum iframe height when page count cannot be determined. */
export const REPORT_ATTACHMENT_PDF_MIN_HEIGHT = "75vh";

/** @deprecated Use REPORT_ATTACHMENT_PDF_VIEWER_HASH */
export const SUMMARY_OF_RIGHTS_PDF_VIEWER_HASH =
  REPORT_ATTACHMENT_PDF_VIEWER_HASH;
